export { default } from "./NowPlaying";
